import { render, staticRenderFns } from "./AddTransporterPopup.vue?vue&type=template&id=a6456f02&scoped=true"
import script from "./AddTransporterPopup.vue?vue&type=script&lang=js"
export * from "./AddTransporterPopup.vue?vue&type=script&lang=js"
import style0 from "./AddTransporterPopup.vue?vue&type=style&index=0&id=a6456f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6456f02",
  null
  
)

export default component.exports